module.exports = __webpack_public_path__ + "static/media/8H.c406e51a.svg";